import React, { useEffect, useRef } from 'react';
interface StepProps {
  number: number;
  title: string;
  description: string;
  variant: 'blue' | 'neon' | 'dark';
  delay?: number;
}
function ProcessStep({
  number,
  title,
  description,
  variant,
  delay = 0
}: StepProps) {
  const variantClasses = {
    blue: 'bg-[linear-gradient(135deg,var(--blue)_0%,var(--blue-dark)_100%)] text-white shadow-[0_0_0_8px_rgba(0,87,255,0.12),0_0_0_1px_rgba(0,87,255,0.4),0_12px_24px_-6px_rgba(0,87,255,0.5)]',
    neon: 'bg-[var(--neon)] text-black shadow-[0_0_0_8px_rgba(204,255,0,0.12),0_0_0_1px_rgba(204,255,0,0.4),0_12px_24px_-6px_rgba(204,255,0,0.4)]',
    dark: 'bg-[var(--bg-3)] text-[var(--text)] border border-[var(--border)] shadow-[0_0_0_8px_rgba(255,255,255,0.03)]'
  };
  return <div className={`flex flex-col items-center text-center px-5 relative z-10 reveal delay-${delay}`} data-id="element-153">
      <div className={`w-20 h-20 rounded-full flex items-center justify-center mb-6 font-black text-[22px] transition-all duration-[0.4s] cubic-bezier-[0.34,1.56,0.64,1] hover:scale-110 ${variantClasses[variant]}`} data-id="element-154">
        {number}
      </div>
      <h3 className="font-extrabold text-base mb-2.5 tracking-tight" data-id="element-155">
        {title}
      </h3>
      <p className="text-[13px] text-[var(--text-muted)] leading-[1.6]" data-id="element-156">
        {description}
      </p>
    </div>;
}
export function Process() {
  const sectionRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -50px 0px'
    });
    const reveals = sectionRef.current?.querySelectorAll('.reveal');
    reveals?.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);
  return <section ref={sectionRef} className="py-12 md:py-[100px] px-6 max-w-[1200px] mx-auto" id="proceso" aria-labelledby="process-title" data-id="element-157">
      <div className="text-center mb-8 md:mb-[72px]" data-id="element-158">
        <div className="inline-flex items-center gap-2 text-[11px] font-extrabold tracking-[0.12em] uppercase text-[var(--blue)] mb-5 reveal before:content-[''] before:block before:w-6 before:h-0.5 before:bg-[var(--blue)] before:rounded-sm" data-id="element-159">
          Nuestro Proceso
        </div>
        <h2 className="font-black text-[clamp(32px,5vw,56px)] leading-[1.05] tracking-[-0.03em] mb-5 reveal delay-1" id="process-title" data-id="element-160">
          De <span className="text-neon" data-id="element-161">idea a web online</span>
          <br data-id="element-162" />
          en 4 pasos simples.
        </h2>
        <p className="text-[17px] text-[var(--text-muted)] leading-[1.65] max-w-[560px] mx-auto reveal delay-2" data-id="element-163">
          Un proceso claro y probado. Tu web estará lista para recibir clientes
          en menos de 7 días hábiles.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-0 relative" data-id="element-164">
        <div className="hidden lg:block absolute top-10 left-[12.5%] right-[12.5%] h-px bg-[linear-gradient(90deg,transparent_0%,var(--border-blue)_20%,var(--border-blue)_80%,transparent_100%)] z-0" aria-hidden="true" data-id="element-165"></div>
        <ProcessStep number={1} title="Análisis Gratis" description="Analizamos tu negocio, competencia y objetivos. Te mostramos exactamente qué necesitas." variant="blue" delay={0} data-id="element-166" />
        <ProcessStep number={2} title="Diseño & Contenido" description="Creamos el diseño personalizado y escribimos el contenido optimizado para SEO y conversión." variant="dark" delay={1} data-id="element-167" />
        <ProcessStep number={3} title="Desarrollo & IA" description="Programamos tu web, integramos la IA y configuramos analytics. Todo listo en 7 días." variant="neon" delay={2} data-id="element-168" />
        <ProcessStep number={4} title="Lanzamiento" description="Publicamos tu web, te capacitamos y te damos soporte continuo. Empiezas a recibir leads." variant="dark" delay={3} data-id="element-169" />
      </div>
    </section>;
}